import { render, staticRenderFns } from "./Germplasm.vue?vue&type=template&id=3b547b7c&"
import script from "./Germplasm.vue?vue&type=script&lang=js&"
export * from "./Germplasm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports